import React from 'react';
import { SvgIcon } from '@mui/material';
import { FileIconProps } from './FileIcon.props';

const FONT_SIZE_MAP = {
  inherit: 'inherit',
  small: 24,
  medium: 40,
  large: 56,
};

export const FileIcon: React.FC<FileIconProps> = ({
  extension,
  fontSize = 'medium',
  sx,
  ...props
}) => {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 40 40"
      sx={{
        fontSize: FONT_SIZE_MAP[fontSize],
        ...sx,
      }}
    >
      <defs>
        <linearGradient
          id={`paint0_linear_file_icon_${extension}`}
          x1="29.4889"
          y1="4.04102"
          x2="33.7442"
          y2="13.7422"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7E8FE5" />
          <stop offset="1" stopColor="#596ED8" />
        </linearGradient>
        <linearGradient
          id={`paint1_linear_file_icon_${extension}`}
          x1="20.628"
          y1="19.8301"
          x2="23.9081"
          y2="24.4238"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7E8FE5" />
          <stop offset="1" stopColor="#596ED8" />
        </linearGradient>
        <linearGradient
          id={`paint2_linear_file_icon_${extension}`}
          x1="20"
          y1="3"
          x2="38.3471"
          y2="38.78"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7E8FE5" />
          <stop offset="1" stopColor="#596ED8" />
        </linearGradient>
        <linearGradient
          id={`paint3_linear_file_icon_${extension}`}
          x1="13.3857"
          y1="19.8438"
          x2="14.8606"
          y2="22.481"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7E8FE5" />
          <stop offset="1" stopColor="#596ED8" />
        </linearGradient>
      </defs>

      <path
        d="M32.0691 13.0002H33.2003C33.3518 13.0057 33.5014 12.9653 33.6295 12.884C33.7575 12.8028 33.8579 12.6848 33.9175 12.5453C33.977 12.4059 33.9929 12.2517 33.9631 12.1031C33.9333 11.9544 33.8591 11.8183 33.7503 11.7127L26.3003 4.28145C26.1966 4.16945 26.0612 4.09176 25.9122 4.05876C25.7631 4.02575 25.6076 4.03901 25.4663 4.09675C25.325 4.15449 25.2047 4.25397 25.1214 4.3819C25.0381 4.50983 24.9959 4.66013 25.0003 4.8127V5.94395C25.0003 6.87164 25.1832 7.79023 25.5386 8.64715C25.894 9.50407 26.4149 10.2825 27.0715 10.9379C27.728 11.5933 28.5074 12.1128 29.3649 12.4667C30.2225 12.8205 31.1414 13.0018 32.0691 13.0002Z"
        fill={`url(#paint0_linear_file_icon_${extension})`}
      />
      <path
        d="M32.0687 15.5C30.8127 15.5016 29.5687 15.2557 28.4079 14.7762C27.247 14.2967 26.1921 13.593 25.3034 12.7055C24.4147 11.8179 23.7096 10.7639 23.2286 9.60367C22.7476 8.44343 22.5 7.19976 22.5 5.94376C22.5 5.16519 22.1916 4.41832 21.6422 3.86662C21.0928 3.31492 20.3473 3.00332 19.5687 3.00001H12.0687C11.1411 2.99837 10.2221 3.17967 9.3646 3.53354C8.50705 3.88742 7.7277 4.40692 7.07114 5.06231C6.41459 5.71771 5.89371 6.49614 5.53832 7.35306C5.18293 8.20998 5 9.12857 5 10.0563V30.9437C5 31.8714 5.18293 32.79 5.53832 33.6469C5.89371 34.5039 6.41459 35.2823 7.07114 35.9377C7.7277 36.5931 8.50705 37.1126 9.3646 37.4665C10.2221 37.8203 11.1411 38.0016 12.0687 38H27.9625C29.8307 37.995 31.6206 37.2494 32.9399 35.9266C34.2591 34.6039 35 32.8119 35 30.9437V18.4438C35 17.6652 34.6916 16.9183 34.1422 16.3666C33.5928 15.8149 32.8473 15.5033 32.0687 15.5Z"
        fill={`url(#paint2_linear_file_icon_${extension})`}
      />

      <text
        x="20"
        y="25"
        textAnchor="middle"
        dominantBaseline="middle"
        fill="white"
        fontSize="9"
        fontWeight="bold"
        fontFamily="Arial, sans-serif"
        style={{ textTransform: 'uppercase' }}
      >
        {extension}
      </text>
    </SvgIcon>
  );
};

export default FileIcon;
